// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SignTada Docs - Matches Dashboard (Global.css) theme */

:root,
[data-theme="dark"] {
  /* Full black docs main content (no boxes / different shades) */
  --docs-bg-primary: #000000;
  --docs-bg-main: #000000;
  --docs-bg-secondary: #000000;
  --docs-bg-tertiary: #0a0a0a;
  --docs-bg-card: #000000;
  --docs-text-primary: #fafafa;
  --docs-text-secondary: #d4d4d4;
  --docs-text-muted: #a3a3a3;
  --docs-border: #1a1a1a;
  --docs-border-light: #262626;
  --docs-sidebar-bg: #050505;
  --docs-header-bg: #0a0a0a;
  --docs-code-bg: #0a0a0a;
  --docs-code-border: #262626;
  --docs-primary: #FFD600;
  --docs-primary-dark: #F57F17;
  --docs-link: #FFD600;
  --docs-link-hover: #FFEA00;
  --docs-method-get: #10b981;
  --docs-method-post: #3b82f6;
  --docs-method-put: #f59e0b;
  --docs-method-patch: #f59e0b;
  --docs-method-delete: #ef4444;
}

[data-theme="light"] {
  --docs-bg-primary: #ffffff;
  --docs-bg-secondary: #f9fafb;
  --docs-bg-tertiary: #f3f4f6;
  --docs-bg-card: #ffffff;
  --docs-text-primary: #111827;
  --docs-text-secondary: #4b5563;
  --docs-text-muted: #6b7280;
  --docs-border: #e5e7eb;
  --docs-border-light: #d1d5db;
  --docs-sidebar-bg: #fafafa;
  --docs-header-bg: #ffffff;
  --docs-code-bg: #f3f4f6;
  --docs-code-border: #e5e7eb;
  --docs-primary: #F57F17;
  --docs-primary-dark: #d97706;
  --docs-link: #d97706;
  --docs-link-hover: #b45309;
  --docs-method-get: #059669;
  --docs-method-post: #2563eb;
  --docs-method-put: #d97706;
  --docs-method-patch: #d97706;
  --docs-method-delete: #dc2626;
}

.docs-app {
  min-height: 100vh;
  background: var(--docs-bg-primary);
  color: var(--docs-text-primary);
  transition: background-color 0.2s, color 0.2s;
}

/* Header */
.docs-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--docs-header-bg);
  border-bottom: 1px solid var(--docs-border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.docs-header-content {
  max-width: 1200px;
  margin: 0;
  margin-left: 24px;
  padding: 0 24px 0 0;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* Logo on the left, then nav tabs */
.docs-header-brand {
  display: flex;
  align-items: center;
  gap: 48px;
}

.docs-header-logo {
  text-decoration: none;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  display: flex;
  align-items: center;
  line-height: 1;
}
.docs-header-logo-sign {
  color: var(--docs-text-primary);
}
.docs-header-logo-tada {
  color: #FFD600;
}
.docs-header-logo:hover .docs-header-logo-sign {
  color: var(--docs-text-secondary);
}
.docs-header-logo:hover .docs-header-logo-tada {
  color: #FFEA00;
}

.docs-menu-btn {
  display: none;
  background: transparent;
  border: none;
  color: var(--docs-text-primary);
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s;
}

.docs-menu-btn:hover {
  background: var(--docs-bg-tertiary);
}

.docs-logo {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: var(--docs-text-primary);
  text-decoration: none;
  transition: color 0.2s;
}

.docs-logo:hover {
  color: var(--docs-primary);
}

.docs-top-nav {
  display: flex;
  gap: 28px;
  align-items: center;
}

.docs-top-nav a {
  color: var(--docs-text-secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  padding: 8px 0;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.docs-top-nav a:hover {
  color: var(--docs-text-primary);
}

.docs-top-nav a.active {
  color: var(--docs-primary);
  border-bottom-color: var(--docs-primary);
}


/* Theme toggle removed - documentation always uses default yellow/black; dashboard theme does not affect this tab */

/* Layout - use full width (Ultravox-style), minimal side margins */
.docs-layout {
  display: flex;
  width: 100%;
  max-width: none;
  margin: 0;
  min-height: calc(100vh - 64px);
}

/* Sidebar */
.docs-sidebar {
  width: 280px;
  background: var(--docs-sidebar-bg);
  border-right: 1px solid var(--docs-border);
  padding: 24px 0;
  position: sticky;
  top: 64px;
  height: calc(100vh - 64px);
  overflow-y: auto;
  transition: transform 0.3s ease;
}

.docs-sidebar-overlay {
  display: none;
}

.docs-sidebar-search {
  padding: 20px 16px 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--docs-border);
}
.docs-sidebar-search input {
  width: 100%;
  padding: 10px 12px 10px 36px;
  border: 1px solid var(--docs-border);
  border-radius: 8px;
  background: var(--docs-bg-tertiary);
  color: var(--docs-text-primary);
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
}
.docs-sidebar-search input::placeholder {
  color: var(--docs-text-muted);
}
.docs-sidebar-search input:focus {
  border-color: var(--docs-primary);
}
.docs-sidebar-search-wrap {
  position: relative;
}
.docs-sidebar-search-wrap .docs-sidebar-search-kbd {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--docs-text-muted);
  font-size: 14px;
  pointer-events: none;
}
.docs-sidebar-search-kbd + input { padding-left: 36px; }

.docs-sidebar-header {
  padding: 0 24px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--docs-border);
  margin-bottom: 16px;
}

.docs-sidebar-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--docs-text-muted);
}

.docs-sidebar-close {
  display: none;
  background: transparent;
  border: none;
  color: var(--docs-text-primary);
  cursor: pointer;
  padding: 4px;
}

.docs-sidebar-nav {
  padding: 0 16px;
}

.docs-sidebar-section {
  margin-bottom: 24px;
}

.docs-sidebar-section-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--docs-text-muted);
  padding: 0 8px;
  margin-bottom: 8px;
}

.docs-sidebar-link {
  display: block;
  padding: 8px 12px;
  color: var(--docs-text-secondary);
  text-decoration: none;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  margin-bottom: 2px;
}

.docs-sidebar-link:hover {
  background: var(--docs-bg-tertiary);
  color: var(--docs-text-primary);
}

.docs-sidebar-link.active {
  background: var(--docs-bg-tertiary);
  color: var(--docs-primary);
  font-weight: 600;
  border-left: 3px solid var(--docs-primary);
  padding-left: 9px;
  margin-left: 0;
}

.docs-sidebar-endpoint-group {
  margin-bottom: 2px;
}
.docs-sidebar-endpoints {
  padding-left: 8px;
  margin-top: 2px;
  margin-bottom: 8px;
  border-left: 2px solid var(--docs-border);
}
.docs-sidebar-sublink {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  font-size: 13px;
  color: var(--docs-text-muted);
}
.docs-sidebar-sublink:hover {
  color: var(--docs-text-secondary);
  background: transparent;
}
.docs-sidebar-method {
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}
.docs-sidebar-method.docs-method-get { background: var(--docs-method-get); color: white; }
.docs-sidebar-method.docs-method-post { background: var(--docs-method-post); color: white; }
.docs-sidebar-method.docs-method-put,
.docs-sidebar-method.docs-method-patch { background: var(--docs-method-put); color: white; }
.docs-sidebar-method.docs-method-delete { background: var(--docs-method-delete); color: white; }

/* Main Content - right of sidebar/scroll; tabs at top then content */
.docs-main {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Documentation / API Reference - to the right of the scroll line */
.docs-content-tabs {
  display: flex;
  gap: 0;
  padding: 20px 24px 0;
  margin-bottom: 0;
  border-bottom: 1px solid var(--docs-border);
  flex-shrink: 0;
}
.docs-content-tab {
  padding: 12px 0 14px;
  margin-right: 28px;
  color: var(--docs-text-secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-color 0.2s;
}
.docs-content-tab:hover {
  color: var(--docs-text-primary);
}
.docs-content-tab.active {
  color: var(--docs-primary);
  border-bottom-color: var(--docs-primary);
}

.docs-main-content {
  flex: 1 1;
  padding: 32px 24px 48px;
  overflow-y: auto;
  background: var(--docs-bg-primary);
}

.docs-content h1 {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 16px;
  color: var(--docs-text-primary);
}

.docs-content h2 {
  font-size: 28px;
  font-weight: 700;
  margin-top: 48px;
  margin-bottom: 16px;
  color: var(--docs-text-primary);
  padding-bottom: 8px;
  border-bottom: 1px solid var(--docs-border);
}

.docs-content h3 {
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 12px;
  color: var(--docs-text-primary);
}

.docs-content p {
  margin-bottom: 16px;
  color: var(--docs-text-secondary);
  line-height: 1.7;
}

.docs-content .docs-lead {
  font-size: 18px;
  color: var(--docs-text-primary);
  margin-bottom: 24px;
  line-height: 1.6;
}

.docs-content code {
  background: var(--docs-code-bg);
  border: 1px solid var(--docs-code-border);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: var(--docs-text-primary);
}

.docs-content pre {
  background: var(--docs-code-bg);
  border: 1px solid var(--docs-code-border);
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 16px 0;
}

.docs-content pre code {
  background: transparent;
  border: none;
  padding: 0;
}

.docs-content a {
  color: var(--docs-link);
  text-decoration: none;
  transition: color 0.2s;
}

.docs-content a:hover {
  color: var(--docs-link-hover);
  text-decoration: underline;
}

.docs-content ul, .docs-content ol {
  margin-left: 24px;
  margin-bottom: 16px;
  color: var(--docs-text-secondary);
}

.docs-content li {
  margin-bottom: 8px;
  line-height: 1.6;
}

/* API Endpoint Card */
.api-endpoint {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0 0 32px;
  margin-bottom: 0;
  border-bottom: 1px solid var(--docs-border);
}
.api-endpoint:last-child {
  border-bottom: none;
}

.api-endpoint-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.api-method {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.api-method.get {
  background: var(--docs-method-get);
  color: white;
}

.api-method.post {
  background: var(--docs-method-post);
  color: white;
}

.api-method.put {
  background: var(--docs-method-put);
  color: white;
}

.api-method.patch {
  background: var(--docs-method-patch);
  color: white;
}

.api-method.delete {
  background: var(--docs-method-delete);
  color: white;
}

.api-path {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: var(--docs-text-primary);
  font-weight: 600;
}

.api-description {
  color: var(--docs-text-secondary);
  margin-bottom: 20px;
  line-height: 1.6;
}

.api-section {
  margin-bottom: 20px;
}

.api-section-title {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--docs-text-muted);
  margin-bottom: 12px;
}

.api-param {
  margin-bottom: 12px;
  padding: 12px;
  background: var(--docs-bg-primary);
  border: 1px solid var(--docs-border);
  border-radius: 6px;
}

.api-param-name {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: var(--docs-text-primary);
  margin-bottom: 4px;
}

.api-param-type {
  font-size: 12px;
  color: var(--docs-text-muted);
  margin-bottom: 4px;
}

.api-param-desc {
  font-size: 13px;
  color: var(--docs-text-secondary);
  line-height: 1.5;
}

.api-param-required {
  display: inline-block;
  padding: 2px 6px;
  background: var(--docs-method-delete);
  color: white;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 3px;
  margin-left: 8px;
}

/* API Try it + two-column layout (Ultravox-style) */
.docs-api-layout {
  display: flex;
  gap: 32px;
  align-items: flex-start;
  max-width: none;
}
.docs-api-main {
  flex: 1 1;
  min-width: 0;
  background: var(--docs-bg-main);
}
.docs-api-right {
  width: 420px;
  flex-shrink: 0;
  position: sticky;
  top: 88px;
}
@media (max-width: 1200px) {
  .docs-api-right { width: 320px; }
}
@media (max-width: 1024px) {
  .docs-api-layout { flex-direction: column; }
  .docs-api-right { width: 100%; position: static; }
}

.api-endpoint-header-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.api-tryit-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--docs-method-get);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-left: auto;
}
.api-tryit-btn:hover { opacity: 0.9; }
.api-tryit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.api-tryit-btn.post { background: var(--docs-method-post); }
.api-tryit-btn.put, .api-tryit-btn.patch { background: var(--docs-method-put); }
.api-tryit-btn.delete { background: var(--docs-method-delete); }

/* Try it modal – popup only; no form on main page */
.api-tryit-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.api-tryit-modal {
  background: var(--docs-bg-primary);
  border: 1px solid var(--docs-border);
  border-radius: 12px;
  max-width: 560px;
  width: 100%;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.5);
}
.api-tryit-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--docs-border);
  flex-shrink: 0;
}
.api-tryit-modal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--docs-text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
}
.api-tryit-modal-close {
  background: none;
  border: none;
  color: var(--docs-text-muted);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
}
.api-tryit-modal-close:hover {
  color: var(--docs-text-primary);
}
.api-tryit-modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}
.api-tryit-modal-body .api-tryit-section {
  padding: 0;
  margin-top: 0;
}
.api-tryit-modal-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--docs-border);
  flex-shrink: 0;
}
.api-tryit-send-btn {
  width: 100%;
  justify-content: center;
}

.api-tryit-section {
  margin-top: 20px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
}
.api-tryit-section .api-section-title { margin-bottom: 12px; }
.api-tryit-auth select,
.api-tryit-auth input,
.api-tryit-body textarea,
.api-tryit-fields input {
  width: 100%;
  max-width: 480px;
  padding: 10px 12px;
  border: 1px solid var(--docs-border);
  border-radius: 6px;
  background: var(--docs-bg-primary);
  color: var(--docs-text-primary);
  font-size: 13px;
  font-family: inherit;
  margin-bottom: 8px;
}
.api-tryit-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.api-tryit-field label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--docs-text-primary);
  margin-bottom: 4px;
}
.api-tryit-field-desc {
  font-size: 12px;
  color: var(--docs-text-muted);
  margin-bottom: 4px;
}
.api-tryit-field-meta {
  font-size: 11px;
  color: var(--docs-text-muted);
  margin-bottom: 6px;
}
.api-tryit-field-type { font-weight: 500; }
.api-param-required {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}
.api-tryit-body textarea,
.api-tryit-field-json {
  min-height: 80px;
  font-family: 'SF Mono', Monaco, monospace;
  font-size: 12px;
  resize: vertical;
}
.api-tryit-field-json {
  width: 100%;
  max-width: 480px;
  padding: 10px 12px;
  border: 1px solid var(--docs-border);
  border-radius: 6px;
  background: var(--docs-bg-primary);
  color: var(--docs-text-primary);
  margin-bottom: 8px;
}
.api-tryit-body textarea {
  min-height: 120px;
}
.api-tryit-auth label,
.api-tryit-body label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--docs-text-muted);
  margin-bottom: 6px;
}
.api-response-box {
  margin-top: 16px;
  padding: 12px;
  border-radius: 0;
  border: none;
  border-top: 1px solid var(--docs-border);
  background: transparent;
  font-size: 12px;
  max-height: 300px;
  overflow: auto;
}
.api-response-box pre { margin: 0; padding: 0; background: transparent; border: none; }
.api-response-status { font-weight: 600; margin-bottom: 8px; }
.api-response-status.ok { color: var(--docs-method-get); }
.api-response-status.err { color: var(--docs-method-delete); }

.api-right-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.api-right-block {
  background: var(--docs-bg-card);
  border: 1px solid var(--docs-border);
  border-radius: 8px;
  overflow: hidden;
}
.api-right-block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: var(--docs-bg-tertiary);
  border-bottom: 1px solid var(--docs-border);
  font-size: 12px;
  font-weight: 700;
  color: var(--docs-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.api-copy-btn {
  padding: 4px 10px;
  background: var(--docs-border);
  border: none;
  border-radius: 4px;
  color: var(--docs-text-secondary);
  font-size: 11px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.api-copy-btn:hover {
  background: var(--docs-primary);
  color: #111;
}

.api-copy-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 28px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--docs-text-muted);
  cursor: pointer;
  transition: color 0.2s, background 0.2s;
}
.api-copy-icon-btn:hover {
  color: var(--docs-primary);
  background: var(--docs-bg-secondary);
}
.api-copy-check {
  color: var(--docs-primary);
  font-size: 14px;
  font-weight: 700;
}
.api-right-block pre {
  margin: 0;
  padding: 14px;
  font-size: 12px;
  line-height: 1.5;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* Response box: wrap long lines (like Ultravox), vertical scroll only when long */
.api-right-block.api-response-block pre,
.api-right-block.api-response-block code {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  overflow-x: hidden;
}
.api-right-block.api-response-block pre {
  max-height: 360px;
}

.api-right-block-head.api-right-block-tabs,
.api-right-block-head.api-right-block-code-head {
  flex-wrap: wrap;
  gap: 8px;
}
.api-lang-dropdown {
  position: relative;
  flex: 1 1;
  min-width: 0;
}
.api-lang-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 500;
  color: var(--docs-text-primary);
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.api-lang-dropdown-trigger:hover {
  background: var(--docs-bg-secondary);
  color: var(--docs-text-primary);
}
.api-lang-chevron {
  opacity: 0.7;
  transition: transform 0.2s;
}
.api-lang-dropdown-trigger[aria-expanded="true"] .api-lang-chevron {
  transform: rotate(180deg);
}
.api-lang-dropdown-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10;
}
.api-lang-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin: 4px 0 0;
  padding: 6px 0;
  min-width: 140px;
  background: var(--docs-bg-card);
  border: 1px solid var(--docs-border);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  list-style: none;
  z-index: 20;
}
.api-lang-dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  font-size: 13px;
  text-align: left;
  background: transparent;
  border: none;
  color: var(--docs-text-secondary);
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.api-lang-dropdown-item:hover,
.api-lang-dropdown-item.active {
  background: var(--docs-bg-tertiary);
  color: var(--docs-primary);
}
.api-code-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}
.api-code-tab {
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--docs-text-muted);
  cursor: pointer;
  transition: color 0.2s, background 0.2s;
}
.api-code-tab:hover {
  color: var(--docs-text-secondary);
  background: var(--docs-bg-tertiary);
}
.api-code-tab.active {
  color: var(--docs-primary);
  background: var(--docs-bg-secondary);
}
.api-code-pre {
  white-space: pre-wrap;
  word-break: break-all;
}

/* Syntax highlight colors (Ultravox-style: purple keywords, orange strings, blue keys, green numbers) */
.code-curl .code-keyword { color: #569cd6; }
.code-curl .code-flag { color: #569cd6; }
.code-curl .code-method { color: #4ec9b0; }
.code-curl .code-string { color: #ce9178; }
.code-curl .code-plain { color: var(--docs-text-secondary); }
.code-python .code-keyword { color: #c586c0; }
.code-python .code-string { color: #ce9178; }
.code-python .code-plain { color: var(--docs-text-primary); }
.code-js .code-keyword { color: #c586c0; }
.code-js .code-string { color: #ce9178; }
.code-js .code-plain { color: var(--docs-text-primary); }
.code-json .code-jsonkey { color: #9cdcfe; }
.code-json .code-string { color: #ce9178; }
.code-json .code-number { color: #b5cea8; }
.code-json .code-plain { color: var(--docs-text-secondary); }
.code-highlight { color: var(--docs-text-secondary); }
[data-theme="light"] .code-curl .code-keyword,
[data-theme="light"] .code-curl .code-flag { color: #0550ae; }
[data-theme="light"] .code-curl .code-string { color: #0a3069; }
[data-theme="light"] .code-curl .code-method { color: #098658; }

/* Responsive */
@media (max-width: 1024px) {
  .docs-sidebar {
    position: fixed;
    left: 0;
    top: 64px;
    height: calc(100vh - 64px);
    z-index: 200;
    transform: translateX(-100%);
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }

  .docs-sidebar.open {
    transform: translateX(0);
  }

  .docs-sidebar-overlay {
    display: block;
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 199;
  }

  .docs-menu-btn {
    display: block;
  }

  .docs-sidebar-close {
    display: block;
  }

  .docs-main {
    padding: 24px;
  }
}

@media (max-width: 768px) {
  .docs-top-nav {
    display: none;
  }

  .docs-main {
    padding: 16px;
  }

  .docs-content h1 {
    font-size: 28px;
  }

  .docs-content h2 {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;;EAEE,+DAA+D;EAC/D,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,iCAAiC;EACjC,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;;AAGA,oHAAoH;;AAEpH,mEAAmE;AACnE;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,SAAS;EACT,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,kCAAkC;EAClC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;AACA,mCAAmC,kBAAkB,EAAE;;AAEvD;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,uCAAuC,kCAAkC,EAAE,YAAY,EAAE;AACzF,wCAAwC,mCAAmC,EAAE,YAAY,EAAE;AAC3F;yCACyC,kCAAkC,EAAE,YAAY,EAAE;AAC3F,0CAA0C,qCAAqC,EAAE,YAAY,EAAE;;AAE/F,qEAAqE;AACrE;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,MAAM;EACN,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,SAAO;EACP,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,kBAAkB,YAAY,EAAE;AAClC;AACA;EACE,mBAAmB,sBAAsB,EAAE;EAC3C,kBAAkB,WAAW,EAAE,gBAAgB,EAAE;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;AACA,uBAAuB,YAAY,EAAE;AACrC,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D,sBAAsB,mCAAmC,EAAE;AAC3D,2CAA2C,kCAAkC,EAAE;AAC/E,wBAAwB,qCAAqC,EAAE;;AAE/D,oDAAoD;AACpD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA,wCAAwC,mBAAmB,EAAE;AAC7D;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;AACA,wBAAwB,gBAAgB,EAAE;AAC1C;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA,wBAAwB,SAAS,EAAE,UAAU,EAAE,uBAAuB,EAAE,YAAY,EAAE;AACtF,uBAAuB,gBAAgB,EAAE,kBAAkB,EAAE;AAC7D,0BAA0B,6BAA6B,EAAE;AACzD,2BAA2B,gCAAgC,EAAE;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,kFAAkF;AAClF;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,uCAAuC;AACzC;AACA;;EAEE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,wGAAwG;AACxG,2BAA2B,cAAc,EAAE;AAC3C,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,yBAAyB,iCAAiC,EAAE;AAC5D,6BAA6B,cAAc,EAAE;AAC7C,4BAA4B,cAAc,EAAE;AAC5C,2BAA2B,+BAA+B,EAAE;AAC5D,yBAAyB,cAAc,EAAE;AACzC,wBAAwB,cAAc,EAAE;AACxC,uBAAuB,+BAA+B,EAAE;AACxD,2BAA2B,cAAc,EAAE;AAC3C,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,yBAAyB,iCAAiC,EAAE;AAC5D,kBAAkB,iCAAiC,EAAE;AACrD;6CAC6C,cAAc,EAAE;AAC7D,+CAA+C,cAAc,EAAE;AAC/D,+CAA+C,cAAc,EAAE;;AAE/D,eAAe;AACf;EACE;IACE,eAAe;IACf,OAAO;IACP,SAAS;IACT,0BAA0B;IAC1B,YAAY;IACZ,4BAA4B;IAC5B,wCAAwC;EAC1C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* SignTada Docs - Matches Dashboard (Global.css) theme */\n\n:root,\n[data-theme=\"dark\"] {\n  /* Full black docs main content (no boxes / different shades) */\n  --docs-bg-primary: #000000;\n  --docs-bg-main: #000000;\n  --docs-bg-secondary: #000000;\n  --docs-bg-tertiary: #0a0a0a;\n  --docs-bg-card: #000000;\n  --docs-text-primary: #fafafa;\n  --docs-text-secondary: #d4d4d4;\n  --docs-text-muted: #a3a3a3;\n  --docs-border: #1a1a1a;\n  --docs-border-light: #262626;\n  --docs-sidebar-bg: #050505;\n  --docs-header-bg: #0a0a0a;\n  --docs-code-bg: #0a0a0a;\n  --docs-code-border: #262626;\n  --docs-primary: #FFD600;\n  --docs-primary-dark: #F57F17;\n  --docs-link: #FFD600;\n  --docs-link-hover: #FFEA00;\n  --docs-method-get: #10b981;\n  --docs-method-post: #3b82f6;\n  --docs-method-put: #f59e0b;\n  --docs-method-patch: #f59e0b;\n  --docs-method-delete: #ef4444;\n}\n\n[data-theme=\"light\"] {\n  --docs-bg-primary: #ffffff;\n  --docs-bg-secondary: #f9fafb;\n  --docs-bg-tertiary: #f3f4f6;\n  --docs-bg-card: #ffffff;\n  --docs-text-primary: #111827;\n  --docs-text-secondary: #4b5563;\n  --docs-text-muted: #6b7280;\n  --docs-border: #e5e7eb;\n  --docs-border-light: #d1d5db;\n  --docs-sidebar-bg: #fafafa;\n  --docs-header-bg: #ffffff;\n  --docs-code-bg: #f3f4f6;\n  --docs-code-border: #e5e7eb;\n  --docs-primary: #F57F17;\n  --docs-primary-dark: #d97706;\n  --docs-link: #d97706;\n  --docs-link-hover: #b45309;\n  --docs-method-get: #059669;\n  --docs-method-post: #2563eb;\n  --docs-method-put: #d97706;\n  --docs-method-patch: #d97706;\n  --docs-method-delete: #dc2626;\n}\n\n.docs-app {\n  min-height: 100vh;\n  background: var(--docs-bg-primary);\n  color: var(--docs-text-primary);\n  transition: background-color 0.2s, color 0.2s;\n}\n\n/* Header */\n.docs-header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: var(--docs-header-bg);\n  border-bottom: 1px solid var(--docs-border);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.docs-header-content {\n  max-width: 1200px;\n  margin: 0;\n  margin-left: 24px;\n  padding: 0 24px 0 0;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n/* Logo on the left, then nav tabs */\n.docs-header-brand {\n  display: flex;\n  align-items: center;\n  gap: 48px;\n}\n\n.docs-header-logo {\n  text-decoration: none;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n}\n.docs-header-logo-sign {\n  color: var(--docs-text-primary);\n}\n.docs-header-logo-tada {\n  color: #FFD600;\n}\n.docs-header-logo:hover .docs-header-logo-sign {\n  color: var(--docs-text-secondary);\n}\n.docs-header-logo:hover .docs-header-logo-tada {\n  color: #FFEA00;\n}\n\n.docs-menu-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  color: var(--docs-text-primary);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 6px;\n  transition: background 0.2s;\n}\n\n.docs-menu-btn:hover {\n  background: var(--docs-bg-tertiary);\n}\n\n.docs-logo {\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  color: var(--docs-text-primary);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.docs-logo:hover {\n  color: var(--docs-primary);\n}\n\n.docs-top-nav {\n  display: flex;\n  gap: 28px;\n  align-items: center;\n}\n\n.docs-top-nav a {\n  color: var(--docs-text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 15px;\n  padding: 8px 0;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n}\n\n.docs-top-nav a:hover {\n  color: var(--docs-text-primary);\n}\n\n.docs-top-nav a.active {\n  color: var(--docs-primary);\n  border-bottom-color: var(--docs-primary);\n}\n\n\n/* Theme toggle removed - documentation always uses default yellow/black; dashboard theme does not affect this tab */\n\n/* Layout - use full width (Ultravox-style), minimal side margins */\n.docs-layout {\n  display: flex;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  min-height: calc(100vh - 64px);\n}\n\n/* Sidebar */\n.docs-sidebar {\n  width: 280px;\n  background: var(--docs-sidebar-bg);\n  border-right: 1px solid var(--docs-border);\n  padding: 24px 0;\n  position: sticky;\n  top: 64px;\n  height: calc(100vh - 64px);\n  overflow-y: auto;\n  transition: transform 0.3s ease;\n}\n\n.docs-sidebar-overlay {\n  display: none;\n}\n\n.docs-sidebar-search {\n  padding: 20px 16px 12px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid var(--docs-border);\n}\n.docs-sidebar-search input {\n  width: 100%;\n  padding: 10px 12px 10px 36px;\n  border: 1px solid var(--docs-border);\n  border-radius: 8px;\n  background: var(--docs-bg-tertiary);\n  color: var(--docs-text-primary);\n  font-size: 13px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n.docs-sidebar-search input::placeholder {\n  color: var(--docs-text-muted);\n}\n.docs-sidebar-search input:focus {\n  border-color: var(--docs-primary);\n}\n.docs-sidebar-search-wrap {\n  position: relative;\n}\n.docs-sidebar-search-wrap .docs-sidebar-search-kbd {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--docs-text-muted);\n  font-size: 14px;\n  pointer-events: none;\n}\n.docs-sidebar-search-kbd + input { padding-left: 36px; }\n\n.docs-sidebar-header {\n  padding: 0 24px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--docs-border);\n  margin-bottom: 16px;\n}\n\n.docs-sidebar-title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--docs-text-muted);\n}\n\n.docs-sidebar-close {\n  display: none;\n  background: transparent;\n  border: none;\n  color: var(--docs-text-primary);\n  cursor: pointer;\n  padding: 4px;\n}\n\n.docs-sidebar-nav {\n  padding: 0 16px;\n}\n\n.docs-sidebar-section {\n  margin-bottom: 24px;\n}\n\n.docs-sidebar-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--docs-text-muted);\n  padding: 0 8px;\n  margin-bottom: 8px;\n}\n\n.docs-sidebar-link {\n  display: block;\n  padding: 8px 12px;\n  color: var(--docs-text-secondary);\n  text-decoration: none;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s;\n  margin-bottom: 2px;\n}\n\n.docs-sidebar-link:hover {\n  background: var(--docs-bg-tertiary);\n  color: var(--docs-text-primary);\n}\n\n.docs-sidebar-link.active {\n  background: var(--docs-bg-tertiary);\n  color: var(--docs-primary);\n  font-weight: 600;\n  border-left: 3px solid var(--docs-primary);\n  padding-left: 9px;\n  margin-left: 0;\n}\n\n.docs-sidebar-endpoint-group {\n  margin-bottom: 2px;\n}\n.docs-sidebar-endpoints {\n  padding-left: 8px;\n  margin-top: 2px;\n  margin-bottom: 8px;\n  border-left: 2px solid var(--docs-border);\n}\n.docs-sidebar-sublink {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  font-size: 13px;\n  color: var(--docs-text-muted);\n}\n.docs-sidebar-sublink:hover {\n  color: var(--docs-text-secondary);\n  background: transparent;\n}\n.docs-sidebar-method {\n  flex-shrink: 0;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.docs-sidebar-method.docs-method-get { background: var(--docs-method-get); color: white; }\n.docs-sidebar-method.docs-method-post { background: var(--docs-method-post); color: white; }\n.docs-sidebar-method.docs-method-put,\n.docs-sidebar-method.docs-method-patch { background: var(--docs-method-put); color: white; }\n.docs-sidebar-method.docs-method-delete { background: var(--docs-method-delete); color: white; }\n\n/* Main Content - right of sidebar/scroll; tabs at top then content */\n.docs-main {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Documentation / API Reference - to the right of the scroll line */\n.docs-content-tabs {\n  display: flex;\n  gap: 0;\n  padding: 20px 24px 0;\n  margin-bottom: 0;\n  border-bottom: 1px solid var(--docs-border);\n  flex-shrink: 0;\n}\n.docs-content-tab {\n  padding: 12px 0 14px;\n  margin-right: 28px;\n  color: var(--docs-text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 15px;\n  border-bottom: 2px solid transparent;\n  transition: color 0.2s, border-color 0.2s;\n}\n.docs-content-tab:hover {\n  color: var(--docs-text-primary);\n}\n.docs-content-tab.active {\n  color: var(--docs-primary);\n  border-bottom-color: var(--docs-primary);\n}\n\n.docs-main-content {\n  flex: 1;\n  padding: 32px 24px 48px;\n  overflow-y: auto;\n  background: var(--docs-bg-primary);\n}\n\n.docs-content h1 {\n  font-size: 36px;\n  font-weight: 800;\n  margin-bottom: 16px;\n  color: var(--docs-text-primary);\n}\n\n.docs-content h2 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-top: 48px;\n  margin-bottom: 16px;\n  color: var(--docs-text-primary);\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--docs-border);\n}\n\n.docs-content h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-top: 32px;\n  margin-bottom: 12px;\n  color: var(--docs-text-primary);\n}\n\n.docs-content p {\n  margin-bottom: 16px;\n  color: var(--docs-text-secondary);\n  line-height: 1.7;\n}\n\n.docs-content .docs-lead {\n  font-size: 18px;\n  color: var(--docs-text-primary);\n  margin-bottom: 24px;\n  line-height: 1.6;\n}\n\n.docs-content code {\n  background: var(--docs-code-bg);\n  border: 1px solid var(--docs-code-border);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: var(--docs-text-primary);\n}\n\n.docs-content pre {\n  background: var(--docs-code-bg);\n  border: 1px solid var(--docs-code-border);\n  padding: 16px;\n  border-radius: 8px;\n  overflow-x: auto;\n  margin: 16px 0;\n}\n\n.docs-content pre code {\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n.docs-content a {\n  color: var(--docs-link);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.docs-content a:hover {\n  color: var(--docs-link-hover);\n  text-decoration: underline;\n}\n\n.docs-content ul, .docs-content ol {\n  margin-left: 24px;\n  margin-bottom: 16px;\n  color: var(--docs-text-secondary);\n}\n\n.docs-content li {\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n/* API Endpoint Card */\n.api-endpoint {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0 0 32px;\n  margin-bottom: 0;\n  border-bottom: 1px solid var(--docs-border);\n}\n.api-endpoint:last-child {\n  border-bottom: none;\n}\n\n.api-endpoint-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.api-method {\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.api-method.get {\n  background: var(--docs-method-get);\n  color: white;\n}\n\n.api-method.post {\n  background: var(--docs-method-post);\n  color: white;\n}\n\n.api-method.put {\n  background: var(--docs-method-put);\n  color: white;\n}\n\n.api-method.patch {\n  background: var(--docs-method-patch);\n  color: white;\n}\n\n.api-method.delete {\n  background: var(--docs-method-delete);\n  color: white;\n}\n\n.api-path {\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  color: var(--docs-text-primary);\n  font-weight: 600;\n}\n\n.api-description {\n  color: var(--docs-text-secondary);\n  margin-bottom: 20px;\n  line-height: 1.6;\n}\n\n.api-section {\n  margin-bottom: 20px;\n}\n\n.api-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--docs-text-muted);\n  margin-bottom: 12px;\n}\n\n.api-param {\n  margin-bottom: 12px;\n  padding: 12px;\n  background: var(--docs-bg-primary);\n  border: 1px solid var(--docs-border);\n  border-radius: 6px;\n}\n\n.api-param-name {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: var(--docs-text-primary);\n  margin-bottom: 4px;\n}\n\n.api-param-type {\n  font-size: 12px;\n  color: var(--docs-text-muted);\n  margin-bottom: 4px;\n}\n\n.api-param-desc {\n  font-size: 13px;\n  color: var(--docs-text-secondary);\n  line-height: 1.5;\n}\n\n.api-param-required {\n  display: inline-block;\n  padding: 2px 6px;\n  background: var(--docs-method-delete);\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border-radius: 3px;\n  margin-left: 8px;\n}\n\n/* API Try it + two-column layout (Ultravox-style) */\n.docs-api-layout {\n  display: flex;\n  gap: 32px;\n  align-items: flex-start;\n  max-width: none;\n}\n.docs-api-main {\n  flex: 1;\n  min-width: 0;\n  background: var(--docs-bg-main);\n}\n.docs-api-right {\n  width: 420px;\n  flex-shrink: 0;\n  position: sticky;\n  top: 88px;\n}\n@media (max-width: 1200px) {\n  .docs-api-right { width: 320px; }\n}\n@media (max-width: 1024px) {\n  .docs-api-layout { flex-direction: column; }\n  .docs-api-right { width: 100%; position: static; }\n}\n\n.api-endpoint-header-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n.api-tryit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: var(--docs-method-get);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  margin-left: auto;\n}\n.api-tryit-btn:hover { opacity: 0.9; }\n.api-tryit-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.api-tryit-btn.post { background: var(--docs-method-post); }\n.api-tryit-btn.put, .api-tryit-btn.patch { background: var(--docs-method-put); }\n.api-tryit-btn.delete { background: var(--docs-method-delete); }\n\n/* Try it modal – popup only; no form on main page */\n.api-tryit-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n.api-tryit-modal {\n  background: var(--docs-bg-primary);\n  border: 1px solid var(--docs-border);\n  border-radius: 12px;\n  max-width: 560px;\n  width: 100%;\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.5);\n}\n.api-tryit-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--docs-border);\n  flex-shrink: 0;\n}\n.api-tryit-modal-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--docs-text-primary);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.api-tryit-modal-close {\n  background: none;\n  border: none;\n  color: var(--docs-text-muted);\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n}\n.api-tryit-modal-close:hover {\n  color: var(--docs-text-primary);\n}\n.api-tryit-modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n.api-tryit-modal-body .api-tryit-section {\n  padding: 0;\n  margin-top: 0;\n}\n.api-tryit-modal-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--docs-border);\n  flex-shrink: 0;\n}\n.api-tryit-send-btn {\n  width: 100%;\n  justify-content: center;\n}\n\n.api-tryit-section {\n  margin-top: 20px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n}\n.api-tryit-section .api-section-title { margin-bottom: 12px; }\n.api-tryit-auth select,\n.api-tryit-auth input,\n.api-tryit-body textarea,\n.api-tryit-fields input {\n  width: 100%;\n  max-width: 480px;\n  padding: 10px 12px;\n  border: 1px solid var(--docs-border);\n  border-radius: 6px;\n  background: var(--docs-bg-primary);\n  color: var(--docs-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  margin-bottom: 8px;\n}\n.api-tryit-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.api-tryit-field label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--docs-text-primary);\n  margin-bottom: 4px;\n}\n.api-tryit-field-desc {\n  font-size: 12px;\n  color: var(--docs-text-muted);\n  margin-bottom: 4px;\n}\n.api-tryit-field-meta {\n  font-size: 11px;\n  color: var(--docs-text-muted);\n  margin-bottom: 6px;\n}\n.api-tryit-field-type { font-weight: 500; }\n.api-param-required {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: rgba(239, 68, 68, 0.2);\n  color: #f87171;\n}\n.api-tryit-body textarea,\n.api-tryit-field-json {\n  min-height: 80px;\n  font-family: 'SF Mono', Monaco, monospace;\n  font-size: 12px;\n  resize: vertical;\n}\n.api-tryit-field-json {\n  width: 100%;\n  max-width: 480px;\n  padding: 10px 12px;\n  border: 1px solid var(--docs-border);\n  border-radius: 6px;\n  background: var(--docs-bg-primary);\n  color: var(--docs-text-primary);\n  margin-bottom: 8px;\n}\n.api-tryit-body textarea {\n  min-height: 120px;\n}\n.api-tryit-auth label,\n.api-tryit-body label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--docs-text-muted);\n  margin-bottom: 6px;\n}\n.api-response-box {\n  margin-top: 16px;\n  padding: 12px;\n  border-radius: 0;\n  border: none;\n  border-top: 1px solid var(--docs-border);\n  background: transparent;\n  font-size: 12px;\n  max-height: 300px;\n  overflow: auto;\n}\n.api-response-box pre { margin: 0; padding: 0; background: transparent; border: none; }\n.api-response-status { font-weight: 600; margin-bottom: 8px; }\n.api-response-status.ok { color: var(--docs-method-get); }\n.api-response-status.err { color: var(--docs-method-delete); }\n\n.api-right-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.api-right-block {\n  background: var(--docs-bg-card);\n  border: 1px solid var(--docs-border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.api-right-block-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: var(--docs-bg-tertiary);\n  border-bottom: 1px solid var(--docs-border);\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--docs-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.api-copy-btn {\n  padding: 4px 10px;\n  background: var(--docs-border);\n  border: none;\n  border-radius: 4px;\n  color: var(--docs-text-secondary);\n  font-size: 11px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.api-copy-btn:hover {\n  background: var(--docs-primary);\n  color: #111;\n}\n\n.api-copy-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 28px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: var(--docs-text-muted);\n  cursor: pointer;\n  transition: color 0.2s, background 0.2s;\n}\n.api-copy-icon-btn:hover {\n  color: var(--docs-primary);\n  background: var(--docs-bg-secondary);\n}\n.api-copy-check {\n  color: var(--docs-primary);\n  font-size: 14px;\n  font-weight: 700;\n}\n.api-right-block pre {\n  margin: 0;\n  padding: 14px;\n  font-size: 12px;\n  line-height: 1.5;\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Response box: wrap long lines (like Ultravox), vertical scroll only when long */\n.api-right-block.api-response-block pre,\n.api-right-block.api-response-block code {\n  white-space: pre-wrap;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  overflow-x: hidden;\n}\n.api-right-block.api-response-block pre {\n  max-height: 360px;\n}\n\n.api-right-block-head.api-right-block-tabs,\n.api-right-block-head.api-right-block-code-head {\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.api-lang-dropdown {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n.api-lang-dropdown-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--docs-text-primary);\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.api-lang-dropdown-trigger:hover {\n  background: var(--docs-bg-secondary);\n  color: var(--docs-text-primary);\n}\n.api-lang-chevron {\n  opacity: 0.7;\n  transition: transform 0.2s;\n}\n.api-lang-dropdown-trigger[aria-expanded=\"true\"] .api-lang-chevron {\n  transform: rotate(180deg);\n}\n.api-lang-dropdown-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10;\n}\n.api-lang-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin: 4px 0 0;\n  padding: 6px 0;\n  min-width: 140px;\n  background: var(--docs-bg-card);\n  border: 1px solid var(--docs-border);\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n  list-style: none;\n  z-index: 20;\n}\n.api-lang-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 8px 14px;\n  font-size: 13px;\n  text-align: left;\n  background: transparent;\n  border: none;\n  color: var(--docs-text-secondary);\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.api-lang-dropdown-item:hover,\n.api-lang-dropdown-item.active {\n  background: var(--docs-bg-tertiary);\n  color: var(--docs-primary);\n}\n.api-code-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n.api-code-tab {\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: var(--docs-text-muted);\n  cursor: pointer;\n  transition: color 0.2s, background 0.2s;\n}\n.api-code-tab:hover {\n  color: var(--docs-text-secondary);\n  background: var(--docs-bg-tertiary);\n}\n.api-code-tab.active {\n  color: var(--docs-primary);\n  background: var(--docs-bg-secondary);\n}\n.api-code-pre {\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n/* Syntax highlight colors (Ultravox-style: purple keywords, orange strings, blue keys, green numbers) */\n.code-curl .code-keyword { color: #569cd6; }\n.code-curl .code-flag { color: #569cd6; }\n.code-curl .code-method { color: #4ec9b0; }\n.code-curl .code-string { color: #ce9178; }\n.code-curl .code-plain { color: var(--docs-text-secondary); }\n.code-python .code-keyword { color: #c586c0; }\n.code-python .code-string { color: #ce9178; }\n.code-python .code-plain { color: var(--docs-text-primary); }\n.code-js .code-keyword { color: #c586c0; }\n.code-js .code-string { color: #ce9178; }\n.code-js .code-plain { color: var(--docs-text-primary); }\n.code-json .code-jsonkey { color: #9cdcfe; }\n.code-json .code-string { color: #ce9178; }\n.code-json .code-number { color: #b5cea8; }\n.code-json .code-plain { color: var(--docs-text-secondary); }\n.code-highlight { color: var(--docs-text-secondary); }\n[data-theme=\"light\"] .code-curl .code-keyword,\n[data-theme=\"light\"] .code-curl .code-flag { color: #0550ae; }\n[data-theme=\"light\"] .code-curl .code-string { color: #0a3069; }\n[data-theme=\"light\"] .code-curl .code-method { color: #098658; }\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .docs-sidebar {\n    position: fixed;\n    left: 0;\n    top: 64px;\n    height: calc(100vh - 64px);\n    z-index: 200;\n    transform: translateX(-100%);\n    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .docs-sidebar.open {\n    transform: translateX(0);\n  }\n\n  .docs-sidebar-overlay {\n    display: block;\n    position: fixed;\n    top: 64px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 199;\n  }\n\n  .docs-menu-btn {\n    display: block;\n  }\n\n  .docs-sidebar-close {\n    display: block;\n  }\n\n  .docs-main {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .docs-top-nav {\n    display: none;\n  }\n\n  .docs-main {\n    padding: 16px;\n  }\n\n  .docs-content h1 {\n    font-size: 28px;\n  }\n\n  .docs-content h2 {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
